import { useEffect, useRef } from 'react';
import { useWorkspace } from '@/context/WorkspaceContext';

/** Re-run effect when workspace scope changes (personal vs organization switch). */
export function useWorkspaceScopedEffect(
  effect: () => void | (() => void),
  deps: React.DependencyList = [],
): void {
  const { workspaceScopeKey } = useWorkspace();
  const effectRef = useRef(effect);
  effectRef.current = effect;

  useEffect(() => {
    return effectRef.current();
    // workspaceScopeKey intentionally drives refetch on workspace switch
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceScopeKey, ...deps]);
}
